import { Grid } from "@mui/material";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import React, { useEffect, useState } from "react";
import { useStore } from "utils/useStore";
import { Suggestion } from "../Suggestions/Suggestion";
import AcxButton from "components/UI/AcxButton";
import AcxSelectMulti from "components/UI/Select/BaseSelectComponents/AcxSelectMulti";
import { ApplicationFilterValuesStore } from "stores/ApplicationFilters/ApplicationFilterValuesStore";
import { SimpleTopicCluster } from "stores/ApplicationFilters/ApplicationFiltersStore";
import { observer } from "mobx-react";
import { useCurrentChatStore } from "components/KBo/Stores/useCurrentChat";

export const SelectTopicsAction = observer(({ args }) => {
    const currentChatStore = useCurrentChatStore();
    const valuesStore = useStore(ApplicationFilterValuesStore);
    const [topics, setTopics] = useState<SimpleTopicCluster[] | undefined>(
        undefined,
    );
    const [dialogOpen, setDialogOpen] = useState(false);

    useEffect(() => {
        if (!dialogOpen) return;
        valuesStore.loadTopics();
    }, [dialogOpen, valuesStore]);

    return (
        <React.Fragment>
            <AcxDialog
                isOpen={dialogOpen}
                onClose={() => {
                    setDialogOpen(false);
                }}
                title="Themes"
                maxWidth="lg"
                dialogContentChildren={
                    <AcxSelectMulti
                        id="kbo-topics-multi-select"
                        fullWidth
                        isLoading={valuesStore.getTaskLoading(
                            ApplicationFilterValuesStore.Tasks.LOAD_TOPICS,
                        )}
                        options={valuesStore.topicClusters ?? []}
                        defaultValue={topics}
                        onChange={(options) => {
                            setTopics(!!options ? options : []);
                        }}
                        valueField="id"
                        labelField="topicLabel"
                        containerHeight="auto"
                        maxContainerHeight="96px"
                        alignControls="flex-start"
                        width="24rem"
                        isClearable={true}
                    />
                }
            >
                <AcxButton
                    fullWidth={false}
                    onClick={() => {
                        if (!topics || topics.length === 0) {
                            return;
                        }

                        const userMessage =
                            (args?.displayedMessagePrefix || "") +
                            topics.map((t) => t.topicLabel).join(", ");
                        const input =
                            (args?.llmMessagePrefix ||
                                "Use the following theme IDs in your filters: ") +
                            JSON.stringify(topics.map((t) => t.id));

                        let serverAction = args?.serverAction;
                        if (serverAction) {
                            let args = { ...serverAction.arguments, input };
                            serverAction = {
                                ...serverAction,
                                arguments: args,
                            };
                        }

                        const additionalInformation = {
                            DisplayMessage: userMessage,
                        };

                        currentChatStore?.streamingSubmitInput({
                            manualInput: input,
                            userMessage: userMessage,
                            serverAction: serverAction,
                            additionalInformation: additionalInformation,
                        });
                    }}
                    disabled={!topics || topics.length === 0}
                >
                    Use selected themes
                </AcxButton>
            </AcxDialog>
            <Grid item>
                <Suggestion onClick={() => setDialogOpen((open) => !open)}>
                    {args?.buttonText || "Select Themes"}
                </Suggestion>
            </Grid>
        </React.Fragment>
    );
});
